"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCompactResultsView = exports.getIsHoveredHotel = exports.domain = exports.createIsSetSearchSelector = exports.createIsProccessSelector = exports.createIsEmptySearchSelector = exports.createGetQueriesIDsForMatrix = exports.createGetPricesSelector = exports.createGetOffersFromPrices = exports.createGetIsIncludedOfferIDInPrices = exports.createGetIsDone = exports.createGetHotelsMarkers = exports.createGetCenterByHotelsMarkers = void 0;
var _reselect = require("reselect");
var R = _interopRequireWildcard(require("ramda"));
var _selectors = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/search/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _geolib = require("geolib");
var _constants = require("../../Search/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var domain = exports.domain = function domain(_) {
  return _.searchResults;
};
var isCompactResultsView = exports.isCompactResultsView = (0, _reselect.createSelector)(domain, R.prop('compactResultsView'));
var createIsSetSearchSelector = exports.createIsSetSearchSelector = function createIsSetSearchSelector() {
  var queryIDs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.MAIN_QUERIES;
  return _reselect.createSelector.apply(void 0, _toConsumableArray(R.map(function (queryID) {
    return R.partialRight(_selectors2.isSetSearch, [{
      queryID: queryID
    }]);
  }, queryIDs)).concat([function () {
    for (var _len = arguments.length, results = new Array(_len), _key = 0; _key < _len; _key++) {
      results[_key] = arguments[_key];
    }
    return R.any(Boolean, results);
  }]));
};
var createIsProccessSelector = exports.createIsProccessSelector = function createIsProccessSelector(quriesIDs) {
  return _reselect.createSelector.apply(void 0, _toConsumableArray(R.map(function (queryID) {
    return R.partialRight(_selectors2.isProccess, [{
      queryID: queryID
    }]);
  }, quriesIDs)).concat([function () {
    for (var _len2 = arguments.length, results = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      results[_key2] = arguments[_key2];
    }
    return R.any(Boolean, results);
  }]));
};
var createGetIsDone = exports.createGetIsDone = function createGetIsDone(queryIDs) {
  return _reselect.createSelector.apply(void 0, _toConsumableArray(R.map(function (queryID) {
    return function (state) {
      return !(0, _selectors2.isSetSearch)(state, {
        queryID: queryID
      }) || (0, _selectors2.isDone)(state, {
        queryID: queryID
      });
    };
  }, queryIDs)).concat([function () {
    for (var _len3 = arguments.length, results = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      results[_key3] = arguments[_key3];
    }
    return R.all(Boolean, results);
  }]));
};
var getIsEmptySearch = function getIsEmptySearch(state, props) {
  return (0, _selectors2.isSetSearch)(state, props) ? (0, _selectors2.isDone)(state, props) && !(0, _selectors2.getTotal)(state, props) : true;
};
var createIsEmptySearchSelector = exports.createIsEmptySearchSelector = function createIsEmptySearchSelector() {
  return _reselect.createSelector.apply(void 0, _toConsumableArray(R.map(function (queryID) {
    return R.partialRight(getIsEmptySearch, [{
      queryID: queryID
    }]);
  }, _constants.MAIN_QUERIES)).concat([function () {
    for (var _len4 = arguments.length, results = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      results[_key4] = arguments[_key4];
    }
    return R.all(Boolean, results);
  }]));
};
var getPricesWithOffersHub = function getPricesWithOffersHub(queryID) {
  return (0, _reselect.createSelector)(R.partialRight((0, _selectors.getOffers)(), [{
    queryID: queryID
  }]), R.partialRight(_selectors2.getPrices, [{
    queryID: queryID
  }]), function (offersHub, pricesByPages) {
    return {
      offersHub: offersHub,
      pricesByPages: pricesByPages
    };
  });
};
var getIndexByQueryID = function getIndexByQueryID(queryID, queriesIDs) {
  return R.findIndex(R.equals(queryID), queriesIDs);
};
var getOfferPrice = function getOfferPrice(offer, pricesWithOffersHub, currency, queriesIDs) {
  var offersHubByQueryIDA = pricesWithOffersHub[getIndexByQueryID(offer.queryID, queriesIDs)].offersHub;
  var price = offersHubByQueryIDA[offer.id].price[currency];
  return price;
};
var PRICES_COUNT_AT_PAGE = 20;
var createGetPricesSelector = exports.createGetPricesSelector = function createGetPricesSelector(queriesIDs) {
  return _reselect.createSelector.apply(void 0, [R.partialRight(_selectors3.getQueryParam, [{
    queryID: _constants.MAIN_QUERY_ID,
    paramName: _fn.QUERY_PARAMS.CURRENCY
  }]), R.partialRight(_selectors3.getQueryParam, [{
    queryID: _constants.MAIN_QUERY_ID,
    paramName: _fn.QUERY_PARAMS.PAGE
  }])].concat(_toConsumableArray(R.map(function (queryID) {
    return getPricesWithOffersHub(queryID);
  }, queriesIDs)), [function (currency, activePage) {
    for (var _len5 = arguments.length, pricesWithOffersHub = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
      pricesWithOffersHub[_key5 - 2] = arguments[_key5];
    }
    var pricesGroupedByHotels = {};
    var _iterator = _createForOfIteratorHelper(pricesWithOffersHub.entries()),
      _step;
    try {
      var _loop = function _loop() {
        var _step$value = _slicedToArray(_step.value, 2),
          index = _step$value[0],
          _step$value$1$pricesB = _step$value[1].pricesByPages,
          pricesByPages = _step$value$1$pricesB === void 0 ? [] : _step$value$1$pricesB;
        var _loop2 = function _loop2(page) {
          var pricesByPage = pricesByPages[page] || [];
          pricesByPage.forEach(function (price) {
            var isSetHotel = pricesGroupedByHotels[price.hotelID];
            var offers = R.map(function (id) {
              return {
                id: id,
                pageIndex: page,
                queryID: queriesIDs[index]
              };
            }, price.offers);
            if (isSetHotel) {
              var _pricesGroupedByHotel;
              (_pricesGroupedByHotel = pricesGroupedByHotels[price.hotelID].offers).push.apply(_pricesGroupedByHotel, _toConsumableArray(offers));
            } else {
              pricesGroupedByHotels[price.hotelID] = {
                hotelID: price.hotelID,
                offers: offers
              };
            }
          });
        };
        for (var page = 0; page < activePage; page++) {
          _loop2(page);
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var results = R.call(R.pipe(R.values, R.map(R.over(R.lensProp('offers'), R.sort(function (offerA, offerB) {
      return R.subtract(getOfferPrice(offerA, pricesWithOffersHub, currency, queriesIDs), getOfferPrice(offerB, pricesWithOffersHub, currency, queriesIDs));
    }))), R.sort(function (_ref, _ref2) {
      var _ref$offers = _slicedToArray(_ref.offers, 1),
        offerA = _ref$offers[0];
      var _ref2$offers = _slicedToArray(_ref2.offers, 1),
        offerB = _ref2$offers[0];
      return R.subtract(getOfferPrice(offerA, pricesWithOffersHub, currency, queriesIDs), getOfferPrice(offerB, pricesWithOffersHub, currency, queriesIDs));
    }), R.reduce(function (acc, price) {
      var isLastGroupOfPriceFulled = R.last(acc).length === PRICES_COUNT_AT_PAGE;
      // page = 1
      // groups = [[]] only one ceil of prices
      var isAvailableCountOfGroups = acc.length < activePage;
      var shouldAddNewGroup = isLastGroupOfPriceFulled && isAvailableCountOfGroups;
      if (shouldAddNewGroup) {
        acc.push([]);
      }
      R.last(acc).push(price);
      return acc;
    }, [[]]), function (groupByPages) {
      if (R.isEmpty(groupByPages)) {
        return groupByPages;
      }
      var lastGroup = R.take(PRICES_COUNT_AT_PAGE, groupByPages.pop());
      groupByPages.push(lastGroup);
      return groupByPages;
    }, R.values), pricesGroupedByHotels);
    return results;
  }]));
};
var createGetHotelsMarkers = exports.createGetHotelsMarkers = function createGetHotelsMarkers() {
  return _reselect.createSelector.apply(void 0, [createGetPricesSelector(_constants.MAIN_QUERIES)].concat(_toConsumableArray(R.map(function (queryID) {
    return R.partialRight((0, _selectors2.getHotelsMarkers)(), [{
      queryID: queryID
    }]);
  }, _constants.MAIN_QUERIES)), [function (pricesByPages) {
    var offersMap = R.call(R.pipe(R.flatten, R.map(R.path(['offers', 0])), R.flatten, R.map(function (_ref3) {
      var id = _ref3.id;
      return [id, true];
    }), R.fromPairs), pricesByPages);
    for (var _len6 = arguments.length, entities = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      entities[_key6 - 1] = arguments[_key6];
    }
    return R.filter(function (_ref4) {
      var offerID = _ref4.offerID;
      return offersMap[offerID];
    }, R.flatten(entities));
  }]));
};
var createGetCenterByHotelsMarkers = exports.createGetCenterByHotelsMarkers = function createGetCenterByHotelsMarkers() {
  return (0, _reselect.createSelector)(createGetHotelsMarkers(), function (markers) {
    return !R.isEmpty(markers) ? R.call(R.pipe(R.map(R.applySpec({
      latitude: R.path(['position', 'lat']),
      longitude: R.path(['position', 'lng'])
    })), _geolib.getCenter, R.applySpec({
      lat: R.prop('latitude'),
      lng: R.prop('longitude')
    })), markers) : undefined;
  });
};
var createGetOffersFromPrices = exports.createGetOffersFromPrices = function createGetOffersFromPrices(queryIDs) {
  return (0, _reselect.createSelector)(createGetPricesSelector(queryIDs), (0, _selectors.getOffers)(), function (_ref5, offersHub) {
    var _ref6 = _slicedToArray(_ref5, 1),
      _ref6$ = _ref6[0],
      pricesByFirstPage = _ref6$ === void 0 ? [] : _ref6$;
    var res = R.isEmpty(pricesByFirstPage) ? pricesByFirstPage : R.call(R.pipe(R.map(R.prop('offers')), R.flatten, R.uniqBy(R.prop('id')), R.map(function (_ref7) {
      var id = _ref7.id,
        queryID = _ref7.queryID;
      return R.mergeAll([offersHub[id], {
        queryID: queryID
      }]);
    })), pricesByFirstPage);
    return res;
  });
};
var isEqualPrices = function isEqualPrices(a, b) {
  var maxDiff = R.call(R.when(function (diff) {
    return !Number.isInteger(diff);
  }, function (diff) {
    return Math.floor(diff * 100) / 100;
  }), Math.max(a, b) * 0.5 / 100);
  return Math.abs(a - b) <= maxDiff;
};
var createGetIsIncludedOfferIDInPrices = exports.createGetIsIncludedOfferIDInPrices = function createGetIsIncludedOfferIDInPrices(queryIDs, offerID) {
  return (0, _reselect.createSelector)(createGetIsDone(queryIDs), createIsSetSearchSelector(queryIDs), createGetOffersFromPrices(queryIDs), R.partialRight((0, _selectors.getOffer)(), [{
    offerID: offerID
  }]), R.partialRight(_selectors3.getQueryParam, [{
    queryID: _constants.MAIN_QUERY_ID,
    paramName: _fn.QUERY_PARAMS.CURRENCY
  }]), function (done, isSet, subOffers, targetOffer, currencyCode) {
    return done && isSet ? R.any(function (_ref8) {
      var id = _ref8.id,
        price = _ref8.price;
      return R.or(id === offerID, isEqualPrices(price[currencyCode], targetOffer.price[currencyCode]));
    }, subOffers) : true;
  });
};
var mapperWithIndex = R.addIndex(R.map);
var createGetQueriesIDsForMatrix = exports.createGetQueriesIDsForMatrix = function createGetQueriesIDsForMatrix(hotelID) {
  return _reselect.createSelector.apply(void 0, _toConsumableArray(R.map(function (queryID) {
    return R.partialRight(_selectors3.getQuery, [{
      queryID: queryID
    }]);
  }, _constants.MAIN_QUERIES)).concat([function () {
    for (var _len7 = arguments.length, queries = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      queries[_key7] = arguments[_key7];
    }
    return R.call(R.pipe(R.filter(Boolean), mapperWithIndex(function (query, index) {
      if (query.get(_fn.QUERY_PARAMS.HOTELS).size === 1) {
        return _constants.MAIN_QUERIES[index];
      }
      return "PRICES_MATRIX_".concat(hotelID, "-").concat(_constants.MAIN_QUERIES[index]);
    })), queries);
  }]));
};
var getIsHoveredHotel = exports.getIsHoveredHotel = R.converge(function (hoveredHotels, hotelID) {
  var _hoveredHotels$hotelI;
  return (_hoveredHotels$hotelI = hoveredHotels[hotelID]) !== null && _hoveredHotels$hotelI !== void 0 ? _hoveredHotels$hotelI : false;
}, [R.pipe(domain, R.prop('hoveredHotels')), function (_, _ref9) {
  var hotelID = _ref9.hotelID;
  return hotelID;
}]);